export default "__VITE_ASSET__0GEvjrHD__"